export default {"src":"/_next/static/media/wholegrain.41ffc8c2.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};